<!-- MyForm.vue -->
<template>
  <div>

    <b-alert v-if="!authorized" variant="warning" style="font-size:small" show>{{$ml.get("confreadonly")}}</b-alert>

    <b-row>
      <b-col md="3" cols="12" class="leftcolumn">
        <div class="row flex-column">
          <div class="col-sm-12" v-for="element in elements" :key="element">
            <div
              :class="{ 'selected': selectedElement === element }"
              class="selectable"
              @click="selectElement(element)"
            >
              {{ element }}
            </div>
          </div>
        </div>
      </b-col>
      <b-col md="9" cols="12">
        <form @submit.prevent="pushParams">
          <div v-if="elementSelected === 0">
            <div class="form-group" style="margin-bottom: 40px;">
              <!--<label for="globalActivated">P2P activated:</label>
              &nbsp;
              <input v-model="global.p2pActivated" type="checkbox" id="globalActivated">-->
              <b-btn size="sm" variant="quanteec" v-if="global.p2pActivated" @click="global.p2pActivated=false" :disabled="!authorized">
                <b-icon icon="slash-circle" />
                {{$ml.get("confdeac")}}
              </b-btn>
              <b-btn size="sm" variant="green" v-if="!global.p2pActivated" @click="global.p2pActivated=true" :disabled="!authorized">
                <b-icon icon="check2-square" />
                {{$ml.get("confac")}}
              </b-btn>
            </div>

            <div class="form-group" style="font-size:small">
              <label for="popularity">{{$ml.get("confactnbr")}}</label>
              <b-input v-model="global.popularity" size="sm" type="number" class="form-control" id="popularity" min="0" required :disabled="!authorized"></b-input>
            </div>

            <!-- List of objects -->
            <p style="font-size:small">{{$ml.get("confdactrange")}}</p>
            <div style="font-size:small" v-for="(item, index) in global.prevents" :key="index">
              <b-row class="align-items-center">
                <b-col cols="auto">
                  <div class="form-group">
                    <label v-if="item.type !== 'urlTemplate'">Type (P2P deactivated):</label>
                    <label v-else>Type:</label>
                    <select style="font-size:small" v-model="item.type" class="form-control" :disabled="!authorized">
                      <option value="urlTemplate">URL template</option>
                      <option value="segment">Segment Number</option>
                      <!--<option value="timestamp">Stream timestamp</option>-->
                      <option value="time">Time UTC</option>
                    </select>
                  </div>
                </b-col>
                <b-col v-if="item.type !== 'urlTemplate'">
                  <div class="form-group">
                    <label>{{$ml.get("confdeacsegst")}}</label>
                    <input style="font-size:small" v-model="item.start" type="text" class="form-control" required :disabled="!authorized">
                  </div>
                </b-col>
                <b-col v-if="item.type !== 'urlTemplate'">
                  <div class="form-group">
                    <label>{{$ml.get("confdeacsegend")}}</label>
                    <input style="font-size:small" v-model="item.end" type="text" class="form-control" required :disabled="!authorized">
                  </div>
                </b-col>

                <b-col v-if="item.type === 'urlTemplate'">
                  <div class="form-group">
                    <label>Template:</label>
                    <input style="font-size:small" v-model="item.urlTemplate" type="text" class="form-control" required :disabled="!authorized">
                  </div>
                </b-col>

                <b-col v-if="item.type === 'urlTemplate'">
                  <div>
                     <input style="font-size:small" v-model="item.isExclude" type="checkbox" id="isExclude" :disabled="!authorized">
                     &nbsp;
                    <label for="isExclude" v-if="item.isExclude">{{$ml.get("confdeactemp")}}</label>
                    <label for="isExclude" v-if="!item.isExclude">{{$ml.get("confactemp")}}</label>
                  </div>
                </b-col>
             
                <b-col cols="auto">
                  <b-button size="sm" @click.prevent="removeGlobalPrevent(index)" variant="redsmall" title="Remove range" :disabled="!authorized"><b-icon icon="x"/></b-button>
                </b-col>
              </b-row>
            </div>

            <b-button size="sm" @click.prevent="addGlobalPrevent" variant="darkblue" :disabled="!authorized">+ {{$ml.get("confaddrange")}}</b-button>

            <hr/>

            <div style="font-size:small" class="form-group">
              <label for="percentActivated">{{$ml.get("confactper")}}</label>
              <input v-model="global.percentActivated" type="range" class="form-control-range" id="percentActivated" min="0" max="100" :disabled="!authorized">
              <b-row class="justify-content-center">
                <span>{{ global.percentActivated }}%</span>
              </b-row>
            </div>

            <div style="font-size:small" class="form-group">
              <label for="maxUploadPercent">{{$ml.get("confperband")}}</label>
              <input v-model="global.maxUploadPercent" type="range" class="form-control-range" id="maxUploadPercent" min="0" max="100" :disabled="!authorized">
              <b-row class="justify-content-center">
                <span>{{ global.maxUploadPercent }}%</span>
              </b-row>
            </div>

            <div style="font-size:small" class="form-group">
              <label for="cellularActivated">{{$ml.get("confupcell")}}</label>
              &nbsp;
              <input v-model="global.cellularActivated" type="checkbox" id="cellularActivated" :disabled="!authorized">
            </div>           

            <div style="font-size:small" class="form-group">
              <label for="interIspActivated">{{$ml.get("confinterisp")}}</label>
              &nbsp;
              <input v-model="global.interIsp" type="checkbox" id="interIspActivated" :disabled="!authorized">
            </div>

            
          </div>

          <div v-if="elementSelected === 2">
            <div class="form-group" style="font-size:small;margin-bottom: 40px;">
              <b-btn size="sm" variant="quanteec" v-if="web.p2pActivated" @click="web.p2pActivated=false" :disabled="!authorized">
                <b-icon icon="slash-circle" />
                {{$ml.get("confdeacw")}}
              </b-btn>
              <b-btn size="sm" variant="green" v-if="!web.p2pActivated" @click="web.p2pActivated=true" :disabled="!authorized">
                <b-icon icon="check2-square" />
                {{$ml.get("confacw")}}
              </b-btn>
            </div>
            <div class="form-group" style="font-size:small">
                <label for="numberOfSegmentsToKeepWeb">{{$ml.get("confnbrseg")}}</label>
                <input v-model="web.numberOfSegmentsToKeep" type="range" class="form-control-range" id="numberOfSegmentsToKeepWeb" min="0" max="120">
                <b-row class="justify-content-center">
                  <span>{{ web.numberOfSegmentsToKeep }} segments</span>
                </b-row>
            </div>
            <div class="form-group" style="font-size:small" >
              <label for="webSdkGlobal">{{$ml.get("confglo")}}</label>
              &nbsp;
              <input v-model="web.useGlobal" type="checkbox" id="webSdkGlobal" :disabled="!authorized">
            </div>
            <hr/>
            <div v-if="web.useGlobal">
              <div class="form-group" style="font-size:small">
                <label for="percentActivated">{{$ml.get("confactper")}}</label>
                <input v-model="global.percentActivated" type="range" class="form-control-range" id="percentActivated" min="0" max="100" disabled>
                <b-row class="justify-content-center">
                  <span>{{ global.percentActivated }}%</span>
                </b-row>
              </div>

              <div class="form-group" style="font-size:small">
                <label for="maxUploadPercent">{{$ml.get("confperband")}}</label>
                <input v-model="global.maxUploadPercent" type="range" class="form-control-range" id="maxUploadPercent" min="0" max="100" disabled>
                <b-row class="justify-content-center">
                  <span>{{ global.maxUploadPercent }}%</span>
                </b-row>
              </div>

              <div class="form-group" style="font-size:small">
                <label for="cellularActivated">{{$ml.get("confupcell")}}</label>
                &nbsp;
                <input v-model="global.cellularActivated" type="checkbox" id="cellularActivated" disabled>
              </div>
            </div>

            <div v-if="!web.useGlobal">
              <div class="form-group" style="font-size:small">
                <label for="percentActivated">{{$ml.get("confactper")}}</label>
                <input v-model="web.percentActivated" type="range" class="form-control-range" id="percentActivated" min="0" max="100" :disabled="!authorized">
                <b-row class="justify-content-center">
                  <span>{{ web.percentActivated }}%</span>
                </b-row>
              </div>

              <div class="form-group" style="font-size:small">
                <label for="maxUploadPercent">{{$ml.get("confperband")}}</label>
                <input v-model="web.maxUploadPercent" type="range" class="form-control-range" id="maxUploadPercent" min="0" max="100" :disabled="!authorized">
                <b-row class="justify-content-center">
                  <span>{{ web.maxUploadPercent }}%</span>
                </b-row>
              </div>

              <div class="form-group" style="font-size:small">
                <label for="cellularActivated">{{$ml.get("confupcell")}}</label>
                &nbsp;
                <input v-model="web.cellularActivated" type="checkbox" id="cellularActivated" :disabled="!authorized">
              </div>
            </div>
          </div>

          <div v-if="elementSelected === 3">
            <div class="form-group" style="font-size:small; margin-bottom: 40px;">
              <b-btn size="sm" variant="quanteec" v-if="android.p2pActivated" @click="android.p2pActivated=false" :disabled="!authorized">
                <b-icon icon="slash-circle" />
                {{$ml.get("confdeaca")}}                
              </b-btn>
              <b-btn size="sm" variant="green" v-if="!android.p2pActivated" @click="android.p2pActivated=true" :disabled="!authorized">
                <b-icon icon="check2-square" />                
                {{$ml.get("confaca")}}
              </b-btn>
            </div>
            <div style="font-size:small" class="form-group">
              <label for="androidSdkGlobal">{{$ml.get("confglo")}}</label>
              &nbsp;
              <input v-model="android.useGlobal" type="checkbox" id="androidSdkGlobal" :disabled="!authorized">
            </div>
            <hr/>
            <div style="font-size:small" v-if="android.useGlobal">
              <div class="form-group">
                <label for="percentActivated">{{$ml.get("confactper")}}</label>
                <input v-model="global.percentActivated" type="range" class="form-control-range" id="percentActivated" min="0" max="100" disabled>
                <b-row class="justify-content-center">
                  <span>{{ global.percentActivated }}%</span>
                </b-row>
              </div>

              <div class="form-group">
                <label for="maxUploadPercent">{{$ml.get("confperband")}}</label>
                <input v-model="global.maxUploadPercent" type="range" class="form-control-range" id="maxUploadPercent" min="0" max="100" disabled>
                <b-row class="justify-content-center">
                  <span>{{ global.maxUploadPercent }}%</span>
                </b-row>
              </div>

              <div class="form-group">
                <label for="cellularActivated">{{$ml.get("confupcell")}}</label>
                &nbsp;
                <input v-model="global.cellularActivated" type="checkbox" id="cellularActivated" disabled>
              </div>
            </div>

            <div v-if="!android.useGlobal" style="font-size:small">
              <div class="form-group">
                <label for="percentActivated">{{$ml.get("confactper")}}</label>
                <input v-model="android.percentActivated" type="range" class="form-control-range" id="percentActivated" min="0" max="100" :disabled="!authorized">
                <b-row class="justify-content-center">
                  <span>{{ android.percentActivated }}%</span>
                </b-row>
              </div>

              <div class="form-group">
                <label for="maxUploadPercent">{{$ml.get("confperband")}}</label>
                <input v-model="android.maxUploadPercent" type="range" class="form-control-range" id="maxUploadPercent" min="0" max="100" :disabled="!authorized">
                <b-row class="justify-content-center">               
                  <span>{{ android.maxUploadPercent }}%</span>
                </b-row>
              </div>

              <div class="form-group">
                <label for="cellularActivated">{{$ml.get("confupcell")}}</label>
                &nbsp;
                <input v-model="android.cellularActivated" type="checkbox" id="cellularActivated" :disabled="!authorized">
              </div>
            </div>
          </div>

          <div v-if="elementSelected === 4">
            <div class="form-group" style="margin-bottom: 40px;">
              <b-btn size="sm" variant="quanteec" v-if="ios.p2pActivated" @click="ios.p2pActivated=false" :disabled="!authorized">
                <b-icon icon="slash-circle" />                
                {{$ml.get("confdeaci")}}
              </b-btn>
              <b-btn size="sm" variant="green" v-if="!ios.p2pActivated" @click="ios.p2pActivated=true" :disabled="!authorized">
                <b-icon icon="check2-square" />                
                {{$ml.get("confdeaci")}}
              </b-btn>
            </div>
            <div class="form-group" style="font-size:small">
              <label for="iosSdkGlobal">{{$ml.get("confglo")}}</label>
              &nbsp;
              <input v-model="ios.useGlobal" type="checkbox" id="iosSdkGlobal" :disabled="!authorized">
            </div>
            <hr/>
            <div v-if="ios.useGlobal" style="font-size:small">
              <div class="form-group">
                <label for="percentActivated">{{$ml.get("confactper")}}</label>
                <input v-model="global.percentActivated" type="range" class="form-control-range" id="percentActivated" min="0" max="100" disabled>
                <b-row class="justify-content-center">
                  <span>{{ global.percentActivated }}%</span>
                </b-row>
              </div>

              <div class="form-group">
                <label for="maxUploadPercent">{{$ml.get("confperband")}}</label>
                <input v-model="global.maxUploadPercent" type="range" class="form-control-range" id="maxUploadPercent" min="0" max="100" disabled>
                <b-row class="justify-content-center">
                  <span>{{ global.maxUploadPercent }}%</span>
                </b-row>
              </div>

              <div class="form-group">
                <label for="cellularActivated">{{$ml.get("confupcell")}}</label>
                &nbsp;
                <input v-model="global.cellularActivated" type="checkbox" id="cellularActivated" disabled>
              </div>
            </div>

            <div v-if="!ios.useGlobal" style="font-size:small">
              <div class="form-group">
                <label for="percentActivated">{{$ml.get("confactper")}}</label>
                <input v-model="ios.percentActivated" type="range" class="form-control-range" id="percentActivated" min="0" max="100" :disabled="!authorized">
                <b-row class="justify-content-center">
                  <span>{{ ios.percentActivated }}%</span>
                </b-row>
              </div>

              <div class="form-group">
                <label for="maxUploadPercent">{{$ml.get("confperband")}}</label>
                <input v-model="ios.maxUploadPercent" type="range" class="form-control-range" id="maxUploadPercent" min="0" max="100" :disabled="!authorized">
                <b-row class="justify-content-center">
                  <span>{{ ios.maxUploadPercent }}%</span>
                </b-row>
              </div>

              <div class="form-group">
                <label for="cellularActivated">{{$ml.get("confupcell")}}</label>
                &nbsp;
                <input v-model="ios.cellularActivated" type="checkbox" id="cellularActivated" :disabled="!authorized">
              </div>
            </div>
          </div>

          <div v-if="elementSelected === 1">
                <b-row class="align-items-center justify-content-around">
                  <b-col cols="col-md-5">
                    <b-form-radio size="sm" v-model="authorizations.isAuthorizedIPs" name="some-radiosIP" :value="true" :disabled="!authorized">
                      <font-awesome-icon style="color: #14BF98" :icon="['fas', 'check-circle']" />
                      &nbsp;{{$ml.get('pluginvideoauthip2')}}
                    </b-form-radio>        
                  </b-col>
                  <b-col cols="2" style="font-size:small; text-align:center">
                    - {{$ml.get('or')}} -
                  </b-col>
                  <b-col cols="col-md-5">
                    <b-form-radio size="sm" v-model="authorizations.isAuthorizedIPs" name="some-radiosIP" :value="false" :disabled="!authorized">
                      <font-awesome-icon style="color: red" :icon="['fas', 'minus-circle']" />
                      &nbsp;{{$ml.get('pluginvideounauthip2')}}
                    </b-form-radio>
                  </b-col>
                </b-row>
                <b-row class="align-items-center">
                  <p class="col-md-6" style="font-size:10px; margin-bottom:8px" v-html="$ml.get('pluginvideop5')"></p>
                  <p class="col-md-6" style="font-size:10px; margin-bottom:8px" v-html="$ml.get('pluginvideop6')"></p>
                </b-row>
                <b-row class="justify-content-around align-items-center mb-4">
                  <tags-input class="col-md-6" element-id="tagsaIP" :disabled="!authorizations.isAuthorizedIPs || !authorized" style="font-size:small"
                    v-model="authorizationsTags._authorizedIPs" placeholder="IP address + Enter"></tags-input>
                  <tags-input class="col-md-6" element-id="tagsuIP" :disabled="authorizations.isAuthorizedIPs || !authorized" style="font-size:small"
                    v-model="authorizationsTags._unauthorizedIPs" placeholder="IP address + Enter"></tags-input>
                </b-row>

                <b-row class="align-items-center justify-content-around">
                  <b-col cols="col-md-5">
                    <b-form-radio size="sm" v-model="authorizations.isAuthorizedCountries"  name="some-radiosC" :value="true" :disabled="!authorized">
                      <font-awesome-icon style="color: #14BF98" :icon="['fas', 'check-circle']" />
                      &nbsp;{{$ml.get('pluginvideoauthcountry2')}}
                    </b-form-radio>
                  </b-col>
                  <b-col cols="2" style="font-size:small; text-align:center">
                    - {{$ml.get('or')}} -
                  </b-col>
                  <b-col cols="col-md-5">
                    <b-form-radio size="sm" v-model="authorizations.isAuthorizedCountries"  name="some-radiosC" :value="false" :disabled="!authorized">
                      <font-awesome-icon style="color: red" :icon="['fas', 'minus-circle']" />
                      &nbsp;{{$ml.get('pluginvideounauthcountry2')}}
                    </b-form-radio>
                  </b-col>
                </b-row>

                <b-row class="align-items-center">
                  <p class="col-md-6" style="font-size:10px; margin-bottom:8px" v-html="$ml.get('pluginvideop7')"></p>
                  <p class="col-md-6" style="font-size:10px; margin-bottom:8px" v-html="$ml.get('pluginvideop8')"></p>
                </b-row>
                <b-row class="justify-content-around align-items-center mb-4">
                  <tags-input class="col-md-6" element-id="tagsaC" :disabled="!authorizations.isAuthorizedCountries || !authorized" style="font-size:small"
                    v-model="authorizationsTags._authorizedCountries" placeholder="Country + Enter"></tags-input>
                  <tags-input class="col-md-6" element-id="taguCs" :disabled="authorizations.isAuthorizedCountries || !authorized" style="font-size:small"
                    v-model="authorizationsTags._unauthorizedCountries" placeholder="Country + Enter"></tags-input>
                </b-row>

                <b-row class="align-items-center justify-content-around">
                  <b-col cols="col-md-5">
                    <b-form-radio size="sm" v-model="authorizations.isAuthorizedWebsites"  name="some-radiosW" :value="true" :disabled="!authorized">
                      <font-awesome-icon style="color: #14BF98" :icon="['fas', 'check-circle']" />
                      &nbsp;{{$ml.get('pluginvideowhitewb')}}
                    </b-form-radio>
                  </b-col>
                  <b-col cols="2" style="font-size:small; text-align:center">
                    - {{$ml.get('or')}} -
                  </b-col>
                  <b-col cols="col-md-5">
                    <b-form-radio size="sm" v-model="authorizations.isAuthorizedWebsites"  name="some-radiosW" :value="false" :disabled="!authorized">
                      <font-awesome-icon style="color: red" :icon="['fas', 'minus-circle']" />
                      &nbsp;{{$ml.get('pluginvideoblackwb')}}
                    </b-form-radio>
                  </b-col>
                </b-row>
                <b-row class="align-items-center">
                  <p class="col-md-6" style="font-size:10px; margin-bottom:8px" v-html="$ml.get('pluginvideop9')"></p>
                  <p class="col-md-6" style="font-size:10px; margin-bottom:8px" v-html="$ml.get('pluginvideop10')"></p>
                </b-row>
                <b-row class="justify-content-around align-items-center mb-4">
                  <tags-input class="col-md-6" element-id="tagsaW" :disabled="!authorizations.isAuthorizedWebsites || !authorized" style="font-size:small"
                    v-model="authorizationsTags._whitelistedWebsites" placeholder="Website + Enter"></tags-input>
                  <tags-input class="col-md-6" element-id="tagsuW" :disabled="authorizations.isAuthorizedWebsites || !authorized" style="font-size:small"
                    v-model="authorizationsTags._blacklistedWebsites" placeholder="Website + Enter"></tags-input>
                </b-row>

                <b-row class="justify-content-center">
                  <b-form-checkbox size="sm" id="isStreamingModal" v-model="authorizations.isAuthorizedVPNs" switch :disabled="!authorized">
                    &nbsp;
                    <font-awesome-icon v-if="authorizations.isAuthorizedVPNs" style="color: #14BF98" :icon="['fas', 'check-circle']" />
                    <font-awesome-icon v-if="!authorizations.isAuthorizedVPNs" style="color: red" :icon="['fas', 'minus-circle']" />
                    {{
                      authorizations.isAuthorizedVPNs
                      ? $ml.get('pluginvideoisvpn')
                      : $ml.get('pluginvideoisnotvpn')
                    }}
                  </b-form-checkbox>
                </b-row>
                <b-row v-if="!authorizations.isAuthorizedVPNs" class="justify-content-center mb-4">
                  <tags-input element-id="tags" style="font-size:small; width:250px" 
                    v-model="authorizationsTags._authorizedVPNsList" placeholder="IP address + Enter" :disabled="!authorized"></tags-input>
                </b-row>
          </div>
          <hr />
          <div class="flex-column d-flex justify-content-end" style="margin-top:2rem">
            <div class="flex-fill">
              <b-row class="justify-content-around">
                  <b-button size="sm" type="submit" variant="msstreamblue" :disabled="!authorized">
                    <b-icon icon="check2-circle" />
                    {{$ml.get("confsubmit")}}
                  </b-button>
                  <b-button size="sm" v-if="type === 'video'" variant="mswarning" @click="defaultParams" :disabled="!authorized">
                    <b-icon icon="gear-fill" />
                    {{$ml.get("confdefaultparam")}}
                  </b-button>
              </b-row>
            </div>
          </div>
        </form>
      </b-col>
    </b-row>

    <b-modal ref="successParameters" hide-footer :title="$ml.get('parameters')">
      <small style="line-height:normal">{{$ml.get('parameterstxt')}}</small>
      <hr />
      <b-row class="justify-content-around">
        <b-btn size="sm" class="col-md-3 col-5" variant="quanteeclg" @click="hideModal('successParameters')">
          <font-awesome-icon style="margin-right:5px" :icon="['fas', 'times']" />
          {{$ml.get('close')}}
        </b-btn>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import VideoService from '@/services/video.service.js';
import ConfigurationService from '@/services/configuration.service.js';
import CollectionService from '@/services/collection.service.js';

let videoService = new VideoService();
let configurationService = new ConfigurationService();
let collectionService = new CollectionService();

export default {
  name: 'configparamform',
  data() {
    return {
      elements: ['Global', 'Authorizations', 'Web SDK', 'Android SDK', 'iOS SDK'],
      selectedElement: 'Global',
      authorized: ((this.type === "config" && this.$auth.validateRoles(['modifyConfigurations'])) || (this.type !== "config" && this.$auth.validateRoles(['modifyVideos']))),
      global: {
        p2pActivated: true,
        popularity: 0,
        percentActivated: 100,
        maxUploadPercent: 100,
        cellularActivated: false,
        interIsp: true,
        prevents: [
        
        ],
      },
      web: {
        p2pActivated: true,
        useGlobal: true,
        percentActivated: 100,
        maxUploadPercent: 100,
        numberOfSegmentsToKeep: 20,
        cellularActivated: false,
      },
      android: {
        p2pActivated: true,
        useGlobal: true,
        percentActivated: 100,
        maxUploadPercent: 100,
        cellularActivated: false,
      },
      ios: {
        p2pActivated: true,
        useGlobal: true,
        percentActivated: 100,
        maxUploadPercent: 100,
        cellularActivated: false,
      },
      authorizations: {
        isAuthorizedIPs: true,
        isAuthorizedCountries: true,
        isAuthorizedWebsites: true,
        isAuthorizedVPNs: true,
        authorizedIPs: [],
        unauthorizedIPs: [],
        authorizedCountries: [],
        unauthorizedCountries: [],
        whitelistedWebsites: [],
        blacklistedWebsites: [],
        authorizedVPNsList: []
      },
      authorizationsTags: {
        _authorizedIPs: [],
        _unauthorizedIPs: [],
        _authorizedCountries: [],
        _unauthorizedCountries: [],
        _whitelistedWebsites: [],
        _blacklistedWebsites: [],
        _authorizedVPNsList: []
      }
    };
  },
  props: [
    "type",
    "config",
    "video",
    "collection",
    "readonly"
  ],
  mounted() {
    console.log("Instanciated", this.type, this.video, this.config, this.collection, this.readonly)
    if (this.readonly) {
      this.authorized = false;
    }
    switch(this.type) {
      case 'config':
        this.getParamsForConfig()
        break;
      case 'video':
        this.getParamsForVideo()
        break;
      case 'collection':
        this.getParamsForCollection()
        break;
      default:
        console.log('Unknown parameter type')
    }
    this.validateDefaultValues()
  },
  computed: {
    elementSelected() {
      return this.elements.findIndex(x => x === this.selectedElement);
    },
  },
  methods: {
    showModal(modal) {
      this.$refs[modal].show();
    },
    hideModal(modal) {
      this.$refs[modal].hide();
    },
    submitForm() {
      console.log("Form submitted");
    },
    selectElement(element) {
      this.selectedElement = element;
    },
    addGlobalPrevent() {
      this.global.prevents.push({ type: 'urlTemplate', start: '', end: '', urlTemplate: '', isExclude:  true});
    },
    removeGlobalPrevent(index) {
      this.global.prevents.splice(index, 1);
    },
    getParamsForConfig() {
      let headers = ['global', 'web', 'android', 'ios', 'authorizations'];
      headers.forEach((header) => {
        if (this.config.rules && this.config.rules[header]) {
          for(let key in this[header]) {
            this[header] = {...this[header], ...this.config.rules[header]};
            if (header === "authorizations") {
              for (let key2 in this.config.rules[header]) {
                if (key2.indexOf('_') === -1 && this.config.rules[header][key2].length > 0) {
                  this[header + 'Tags']['_' + key2] = this.config.rules[header][key2].map(x => {return {key: "", value:x}})
                }
              }
            }
          }
        }
      })
    },
    getParamsForVideo() {
      let headers = ['global', 'web', 'android', 'ios', 'authorizations'];
      headers.forEach((header) => {
        if (this.video.rules && this.video.rules[header]) {
          for(let key in this[header]) {
            this[header] = {...this[header], ...this.video.rules[header]};
            if (header === "authorizations") {
              for (let key2 in this.video.rules[header]) {
                if (key2.indexOf('_') === -1 && this.video.rules[header][key2].length > 0) {
                  this[header + 'Tags']['_' + key2] = this.video.rules[header][key2].map(x => {return {key: "", value:x}})
                }
              }
            }
          }
        }
      })
    },
    getParamsForCollection() {
      let headers = ['global', 'web', 'android', 'ios', 'authorizations'];
      headers.forEach((header) => {
        if (this.collection.rules && this.collection.rules[header]) {
          for(let key in this[header]) {
            this[header] = {...this[header], ...this.collection.rules[header]};
            if (header === "authorizations") {
              for (let key2 in this.collection.rules[header]) {
                if (key2.indexOf('_') === -1 && this.collection.rules[header][key2].length > 0) {
                  this[header + 'Tags']['_' + key2] = this.collection.rules[header][key2].map(x => {return {key: "", value:x}})
                }
              }
            }
          }
        }
      })
    },
    validateDefaultValues() {
      if (this.global && !this.global.hasOwnProperty("interIsp")) {
        this.global.interIsp = true;
      }
    },
    validateParams() {
      this.global.popularity = +this.global.popularity
      this.global.percentActivated = +this.global.percentActivated
      this.global.maxUploadPercent = +this.global.maxUploadPercent

      this.web.percentActivated = +this.web.percentActivated
      this.web.maxUploadPercent = +this.web.maxUploadPercent
      this.web.numberOfSegmentsToKeep = +this.web.numberOfSegmentsToKeep

      this.android.percentActivated = +this.android.percentActivated
      this.android.maxUploadPercent = +this.android.maxUploadPercent

      this.ios.percentActivated = +this.ios.percentActivated
      this.ios.maxUploadPercent = +this.ios.maxUploadPercent
      if (this.authorizationsTags._authorizedIPs)
        this.authorizations.authorizedIPs = this.authorizationsTags._authorizedIPs.map(x => x.value)
      if (this.authorizationsTags._unauthorizedIPs)
        this.authorizations.unauthorizedIPs = this.authorizationsTags._unauthorizedIPs.map(x => x.value)
      if (this.authorizationsTags._authorizedCountries)
        this.authorizations.authorizedCountries = this.authorizationsTags._authorizedCountries.map(x => x.value)
      if (this.authorizationsTags._unauthorizedCountries)
        this.authorizations.unauthorizedCountries = this.authorizationsTags._unauthorizedCountries.map(x => x.value)
      if (this.authorizationsTags._whitelistedWebsites)
        this.authorizations.whitelistedWebsites = this.authorizationsTags._whitelistedWebsites.map(x => x.value)
      if (this.authorizationsTags._blacklistedWebsites)
        this.authorizations.blacklistedWebsites = this.authorizationsTags._blacklistedWebsites.map(x => x.value)
      if (this.authorizationsTags._authorizedVPNsList)
        this.authorizations.authorizedVPNsList = this.authorizationsTags._authorizedVPNsList.map(x => x.value)
    },
    pushParams() {
      this.validateParams()
      switch(this.type) {
        case 'config':
          configurationService.putConfiguration(this.config.uuid, {
            rules: {
              global: this.global,
              web: this.web,
              android: this.android,
              ios: this.ios,
              authorizations: this.authorizations
            }
          }, this.$auth.token())
          .then((response) => {
            this.showModal("successParameters")
            console.log("Configuration updated");
          }).catch(err => {
            alert('Error while updating configurations. Please retry later.');
          })
          break;
        case 'video': 
          videoService.putVideoPluginById( {
            rules: {
              global: this.global,
              web: this.web,
              android: this.android,
              ios: this.ios,
              authorizations: this.authorizations
            },
            rulesFromCollection: ""
          }, this.video._id, this.$auth.token())
          .then((response) => {
            //this.video = response;
            console.log("Video updated", response);
            this.$emit('closeModal', true)
          }).catch(err => {
            alert('Error while updating video. Please retry later.');
          })
          break;
        case 'collection':
          collectionService.putCollection(this.collection.uuid, {
            rules: {
              global: this.global,
              web: this.web,
              android: this.android,
              ios: this.ios,
              authorizations: this.authorizations
            }
          }, this.$auth.token())
          .then((response) => {
            console.log("Collection updated");
            this.$emit('closeModal', true)
          }).catch(err => {
            alert('Error while updating [Config]. Please retry later.');
          })
          break;
          /*videoService.putVideoPluginByCollection( {
            rules: {
              global: this.global,
              web: this.web,
              android: this.android,
              ios: this.ios,
              authorizations: this.authorizations
            }
          }, this.collection, this.$auth.token())
          .then((response) => {
            console.log("Collection updated");
            this.$emit('closeModal', true)
          }).catch(err => {
            alert('Error while updating collection. Please retry later.');
          })*/
        default:
          break;
      }
    },
    defaultParams() {
      switch(this.type) {
        case 'video': 
          videoService.putVideoPluginById( {
            rules: null,
            rulesFromCollection: "",
          }, this.video._id, this.$auth.token())
          .then((response) => {
            //this.video = response;
            console.log("Video updated", response);
            this.$emit('closeModal', true)
          }).catch(err => {
            alert('Error while updating video. Please retry later.');
          })
          break;
        case 'collection':
          /*videoService.putVideoPluginByCollection( {
            rules: null
          }, this.collection, this.$auth.token())
          .then((response) => {
            console.log("Collection updated");
            this.$emit('closeModal', true)
          }).catch(err => {
            alert('Error while updating collection. Please retry later.');
          })*/
          break;
        default:
          break;
      }
    }
  },
};
</script>

<style scoped>
.leftcolumn {
  background-color: rgba(0,37,69,0.1);
  border-radius: 10px;
  padding-top: 10px;
  padding-bottom: 10px;
  font-size:small;
  margin-bottom: 10px;
}

.selectable {
  padding: 10px;
  border-radius: 4px;
  cursor: pointer;
  font-size:small;
}

.selected {
  background-color: #2F90B0; /* Bootstrap blue background color */
  color: #fff; /* White text color */
  font-size:small;
}

</style>
